// extracted by mini-css-extract-plugin
export default {"toDoItemsContainer":"toDoList_toDoItemsContainer__ut6kd","emptyError":"toDoList_emptyError__tT+Sh","container":"toDoList_container__SyTG5"};